<template>
	<b-col class="simple-card">
		<span class="title">{{ title }}</span>
		<span class="value">{{ value }}</span>
	</b-col>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: 'Title'
		},
		value: {
			type: Number,
			default: 0
		}
	}
}
</script>
